import api from '../../api/auth'
import { SIGN_IN, GOOGLE_ID, STORY_AUTH, SET_CHAT_REQUESTS_STORY_ID, SET_NOT_REGISTER_STORY } from './constants'

export const signInAction = payload => ({ type: SIGN_IN, payload })
export const storyAuthAction = payload => ({ type: STORY_AUTH, payload })
export const setChatRequesStoryIdAction = payload => ({ type: SET_CHAT_REQUESTS_STORY_ID, payload })
export const setNotRegisterStoryAction = payload => ({ type: SET_NOT_REGISTER_STORY, payload })

export const googleIdActions = payload => ({ type: GOOGLE_ID, payload })

export const signIn = data => dispatch => api.signIn(data)
  .then(res => {
    dispatch(signInAction(res?.data))

    return res
  })
  .catch(err => err)

export const logOut = data => dispatch => dispatch(signInAction(data))

export const googleId = data => dispatch => dispatch(googleIdActions(data))
export const storyLogin = data => dispatch => dispatch(storyAuthAction(data))
export const setChatRequesStoryId = data => dispatch => dispatch(setChatRequesStoryIdAction(data))
export const setNotRegisterStory = data => dispatch => dispatch(setNotRegisterStoryAction(data))
